








































import TaskComponent from './Task.vue';
import {Task, TaskSourceSystem} from "../models/task-viewmodels";
import {defineComponent, PropType, ref, computed} from "@vue/composition-api";
import {useGetters} from "vuex-composition-helpers";

export default defineComponent({
  name: "TasksList",
  components: { TaskComponent },
  props: {
    sourceSystem: {
      type: Object as PropType<TaskSourceSystem>,
      required: true,
    },
    orderByDate: {
      type: String,
      required: true,
    }
  },
  setup: (props) => {
    const showTasks = ref(false);
    const currentSourceSystem = ref(props.sourceSystem);

    const { config } = useGetters(['config'])
    function showTasksToggle() {
      showTasks.value = !showTasks.value;
    }
    function replaceString(text: string, placeholder: string, placeholderText: string): string {
      if(text) {
        return text.replace(placeholder, placeholderText);
      } return '';
    }

    const firstTask = computed(() => {
      if (currentSourceSystem.value.tasks.length === 0) {
        return null;
      }
      return [...currentSourceSystem.value.tasks]
          .sort((a: Task, b: Task) => (a.dueDate > b.dueDate) ? 1 : ((b.dueDate > a.dueDate) ? -1 : 0))[0];
    });


    function firstTaskDate(): string | undefined {
      const task = firstTask.value;
      return task?.isToday ? 'Vandaag' : task?.dueDate;
    }

    function firstTaskDateShort(): string | undefined {
      const task = firstTask.value;
      return task?.isToday ? 'Vandaag' : task?.dueDateShort;
    }

    function firstTaskDateIsPast(): boolean | undefined{
      return firstTask.value?.isPast;
    }
    function tasksByDate(): Task[] {
      const orderedArr = [...currentSourceSystem.value.tasks]
      if (props.orderByDate === 'asc') {
        return orderedArr.sort((a: Task, b: Task) => (a.dueDate > b.dueDate) ? 1 : ((b.dueDate > a.dueDate) ? -1 : 0));
      }

      return orderedArr.sort((a: Task, b: Task) => (a.dueDate < b.dueDate) ? 1 : ((b.dueDate < a.dueDate) ? -1 : 0));
    }
    return {showTasksToggle, showTasks, currentSourceSystem, firstTaskDateIsPast, config, firstTaskDateShort, firstTaskDate, tasksByDate, replaceString}
}
})

